export const colors = {
    black: '#000000',
    blue: '#1B4A67',
    dark_blue: '#00253D',
    red: '#ff0000',
    white: '#ffffff',
}